module.exports = __webpack_public_path__ + "static/media/17UN-Women6.49ab4c43.jpg";